import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import { hasMediaQualityPermission } from './helpers/hasMediaQualityPermission.helper';
import MediaQualityAssuranceSystem from './MediaQualityAssuranceSystem';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  budget?: number;
  currency: BaseCurrencyInterface;
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function MediaQualityAssuranceSystemWrapper({ budget, currency, onChange, targeting, user, userRoles }: Props) {
  if (!hasMediaQualityPermission(user, userRoles)) {
    return null;
  }
  return (
    <TargetingProvider
      budget={budget}
      currency={currency}
      onChange={onChange}
      targeting={targeting}
      user={user}
      userRoles={userRoles}
    >
      <MediaQualityAssuranceSystem />
    </TargetingProvider>
  );
}

export default MediaQualityAssuranceSystemWrapper;
